import { type UseQueryOptions, useQuery } from '@tanstack/vue-query'
import type { Ref } from 'vue'
import type { FetchAirportsSuccessResponse } from '@/modules/Profile/types/api/response/airport'
import { axiosInstance } from '@/modules/Core/plugins/axios'
import { filterNonNullQueryParams } from '@/modules/Core/utils'

export const QUERY_KEY = 'airports'
const ENDPOINT = '/Generic/Airports/Flatten'
type Type = 'Airport' | 'City'

export function fetchAirports(
  query: string,
  page: number,
  size: number,
  excludedGeoTypes?: Array<string>,
  type?: Type
) {
  const params = {
    ...filterNonNullQueryParams({
      query,
      page,
      size,
    }),
    ...(excludedGeoTypes && { excludedGeoTypes }),
    ...(type && { type }),
  }

  return axiosInstance
    .get<FetchAirportsSuccessResponse>(ENDPOINT, {
      params,
      paramsSerializer: {
        indexes: null,
      },
    })
    .then((response) => response.data.data)
}

export function useAirportsQuery(
  query: Ref<string>,
  page: Ref<number>,
  size: Ref<number>,
  excludedGeoTypes?: Ref<Array<string>>,
  type?: Ref<Type>,
  options?: UseQueryOptions<Awaited<ReturnType<typeof fetchAirports>>>
) {
  return useQuery({
    queryKey: [QUERY_KEY, query, page, size, excludedGeoTypes, type],
    queryFn: () =>
      fetchAirports(
        query.value,
        page.value,
        size.value,
        excludedGeoTypes?.value,
        type?.value
      ),
    keepPreviousData: true,
    ...options,
  })
}
